import img from "../../img/image(3).webp";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsParkingPage() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>PARKING</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">
            Solutions de parking couvert & ombrage moderne
          </h1>

          <p data-aos="fade-up">
            US PARKING propose des structures métalliques avec
            toiles techniques pour protéger les véhicules contre
            le soleil, la pluie et les conditions climatiques.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/pdf/US PARKING.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Parking Carport" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US PARKING ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            US PARKING est une solution d’ombrage pour
            parkings basée sur des structures métalliques
            robustes avec des toiles techniques résistantes.
          </p>

          <p data-aos="fade-up">
            Ces installations permettent de protéger les
            véhicules tout en apportant un design moderne
            et une intégration architecturale harmonieuse.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature icon="🚗" title="Protection véhicules" text="Protection contre soleil, pluie et chaleur." />
          <Feature icon="☀️" title="Réduction thermique" text="Température intérieure réduite des véhicules." />
          <Feature icon="🏗️" title="Structure solide" text="Acier galvanisé haute résistance." />
          <Feature icon="🎨" title="Design moderne" text="Adapté aux espaces urbains et professionnels." />
          <Feature icon="⚡" title="Installation rapide" text="Montage rapide et efficace." />
          <Feature icon="🛡️" title="Durabilité" text="Longue durée de vie avec faible maintenance." />
        </div>
      </section>

      {/* TECHNIQUE */}
      <section className="us-section">
        <SectionTitle
          small="Technique"
          big="Caractéristiques techniques"
        />

        <ul data-aos="fade-up" className="us-list">
          <li>Structures métalliques galvanisées</li>
          <li>Toiles techniques PVC ou PVDF</li>
          <li>Résistance aux UV et intempéries</li>
          <li>Design modulable</li>
          <li>Différentes dimensions disponibles</li>
          <li>Fixation au sol sécurisée</li>
        </ul>
      </section>

      {/* APPLICATIONS */}
      <section className="us-section us-gray">
        <SectionTitle
          small="Applications"
          big="Domaines d’utilisation"
        />

        <div className="us-tags" data-aos="fade-up">
          {[
            "Parkings publics",
            "Centres commerciaux",
            "Hôpitaux",
            "Entreprises",
            "Résidences",
            "Écoles",
            "Aéroports",
            "Hôtels",
          ].map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="us-cta">
        <h2>Besoin d’un parking couvert sur mesure ?</h2>
        <p>Contactez UNIK SYSTEM pour votre projet.</p><br/>
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
  );
}